module.exports = __webpack_public_path__ + "img/calendar_clock.3bca6b98.png";